import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import {useServerIncidentsSummary} from 'features/server/model/useServerIncidentsSummary';
import TableBox from 'shared/ui/Box/TableBox/TableBox';
import PlugNoIncidents from 'shared/ui/Plugs/PlugNoIncidents/PlugNoIncidents';
import SummaryStatus from 'shared/ui/SummaryStatus/SummaryStatus';
import ServerIncidents from 'features/server/ui/ServerIncident/ServerIncidents/ServerIncidents';
import IServerOutput from 'features/server/model/Server/IServer';

import LinkButton from '../../../../../../shared/ui/Button/LinkButton/LinkButton';

import styles from './ServerIncidentsSummary.module.scss';

interface IServerIncidentsSummaryProps {
    server: IServerOutput,
}

const ServerIncidentsSummary: React.FC<IServerIncidentsSummaryProps> = ({server}) => {
    const incidentsUrl = `${AppUrls.SERVER_INCIDENTS}?server.uuid=${server.uuid}`;

    const {
        items, isLoading, unresolved, resolved,
    } = useServerIncidentsSummary(server);

    return (
        <TableBox className={styles.section}>
            <div className={styles.header}>
                <div className={styles.headerActions}>
                    <h3 className={styles.sectionTitle}>{t`Инциденты`}</h3>
                    <SummaryStatus
                        unresolved={unresolved}
                        resolved={resolved}
                    />
                </div>
                <LinkButton
                    className={cn(styles.link, styles.brandLink)}
                    href={incidentsUrl}
                >
                    {t`Перейти к списку`}
                </LinkButton>
            </div>

            <ServerIncidents
                pagination={{items, currentPage: 1, lastPage: 1, totalItems: items.length}}
                isLoading={isLoading}
                hideServer
                hidePagination
                className={styles.table}
            />
            {!isLoading && items.length === 0 && <PlugNoIncidents/>}
        </TableBox>
    );
};

export default ServerIncidentsSummary;
